import { gql } from "@apollo/client";

export const FETCH_PURCHASE_PRODUCTS = gql`
  query FETCH_PURCHASE_PRODUCTS {
    products(isActive: true, isPurchasable: true, productType: "normal") {
      total
      results {
        id
        number
        name
      }
    }
  }
`;

export const FETCH_SALE_PRODUCTS = gql`
  query FETCH_SALE_PRODUCTS {
    products(isActive: true, isSalable: true, productType: "normal") {
      total
      results {
        id
        number
        name
      }
    }
  }
`;

export const FETCH_PRODUCT_DETAILS = gql`
  query FETCH_PRODUCT_DETAILS($id: ID!) {
    product(id: $id) {
      id
      name
      number
      activePrices {
        id
        currency
        price
        minQty
        company
        supplier: factory {
          id
          name
        }
      }

      defaultQty
      itemsPerSet
      children {
        id
        product {
          id
          number
          name
          activePrices {
            id
            currency
            price
            minQty
            company
            supplier: factory {
              id
              name
            }
          }
        }
        qty
      }

      defaultQty
    }
  }
`;

export const CREATE_PROJECT = gql`
  mutation CREATE_PROJECT($name: String!) {
    createProject(name: $name) {
      project {
        id
        name
      }
    }
  }
`;

export const FETCH_PROJECTS = gql`
  query FETCH_PROJECTS {
    projects {
      total
      results {
        id
        name
        priority
        startDate
        targetDate
        completedAt
        owner {
          id
          firstName
        }
      }
    }
  }
`;

export const FETCH_PROJECT = gql`
  query FETCH_PROJECT($id: ID!) {
    project(id: $id) {
      id
      name
      goal
      priority
      startDate
      sampleDate
      targetDate
      completedAt
      owner {
        id
        firstName
      }
      data
      imageUrls {
        id
        url
        thumb: url(width: 300)
      }
      gotomarketproject {
        id
        name
      }
    }
  }
`;

export const FETCH_PROJECT_GTM_PROJECTS = gql`
  query FETCH_PROJECT_GTM_PROJECTS($projectId: ID!) {
    project(id: $projectId) {
      id
      gotomarketproject {
        id
        name
      }
    }
  }
`;

const PROJECT_TASK_FRAGMENT = gql`
  fragment ProjectTaskFragment on ProjectTaskType {
    id
    name
    completedAt
    deletedAt
    createdBy {
      id
      email
      firstName
    }
  }
`;

export const FETCH_PROJECT_TASKS = gql`
  query FETCH_PROJECT_TASKS($id: ID!) {
    project(id: $id) {
      id
      tasks {
        ...ProjectTaskFragment
      }
    }
  }
  ${PROJECT_TASK_FRAGMENT}
`;

export const FETCH_GTM_PROJECT_TASKS = gql`
  query FETCH_GTM_PROJECT_TASKS($id: ID!) {
    project: gtmProject(id: $id) {
      id
      tasks {
        ...ProjectTaskFragment
      }
    }
  }
  ${PROJECT_TASK_FRAGMENT}
`;

export const SAVE_PROJECT = gql`
  mutation SAVE_PROJECT(
    $id: ID!
    $goal: String
    $priority: Int
    $startDate: Date
    $sampleDate: Date
    $targetDate: Date
    $ownerId: ID
    $data: String
    $images: String
  ) {
    saveProject(
      id: $id
      goal: $goal
      priority: $priority
      startDate: $startDate
      sampleDate: $sampleDate
      targetDate: $targetDate
      ownerId: $ownerId
      data: $data
      images: $images
    ) {
      project {
        id
        data
        priority
        startDate
        sampleDate
        targetDate
        completedAt
        owner {
          id
          firstName
        }
        imageUrls {
          id
          url
          thumb: url(width: 300)
        }
      }
    }
  }
`;

export const COMPLETE_PROJECT = gql`
  mutation COMPLETE_PROJECT($id: ID!) {
    completeProject(id: $id) {
      project {
        id
        completedAt
      }
    }
  }
`;

export const CREATE_PROJECT_TASK = gql`
  mutation CREATE_PROJECT_TASK(
    $projectId: ID!
    $name: String!
    $projectType: String
  ) {
    createProjectTask(
      projectType: $projectType
      projectId: $projectId
      name: $name
    ) {
      task {
        id
        project {
          id
          tasks {
            ...ProjectTaskFragment
          }
        }
        gtmProject {
          id
          tasks {
            ...ProjectTaskFragment
          }
        }
      }
    }
  }
  ${PROJECT_TASK_FRAGMENT}
`;

export const SAVE_PROJECT_TASK = gql`
  mutation SAVE_PROJECT_TASK($id: ID!, $name: String) {
    saveProjectTask(id: $id, name: $name) {
      task {
        ...ProjectTaskFragment
      }
    }
  }
  ${PROJECT_TASK_FRAGMENT}
`;

export const TOGGLE_PROJECT_TASK = gql`
  mutation TOGGLE_PROJECT_TASK($id: ID!) {
    toggleProjectTask(id: $id) {
      task {
        ...ProjectTaskFragment
      }
    }
  }
  ${PROJECT_TASK_FRAGMENT}
`;

export const DELETE_PROJECT_TASK = gql`
  mutation DELETE_PROJECT_TASK($id: ID!) {
    deleteProjectTask(id: $id) {
      project {
        id
        tasks {
          ...ProjectTaskFragment
        }
      }
    }
  }
  ${PROJECT_TASK_FRAGMENT}
`;

export const FETCH_PROJECT_IDEAS = gql`
  query FETCH_PROJECT_IDEAS {
    projectIdeas {
      id
      content
    }
  }
`;

export const SAVE_PROJECT_IDEA = gql`
  mutation SAVE_PROJECT_IDEA($content: String!, $id: ID) {
    saveProjectIdea(content: $content, id: $id) {
      projectIdea {
        id
        content
      }
    }
  }
`;
